import { useEffect } from 'react'
import { useMappedErrorMessage } from 'hooks/useMappedErrorMessage'
import { BaseErrorResponse } from 'types/beneficiaries'

interface UseFormError {
  fetchingCustomersError: Error
  transferWalletsErrors: Error
}

export const useFormError = ({ fetchingCustomersError, transferWalletsErrors }: UseFormError) => {
  const { requestError, setRequestError, resetRequestError } = useMappedErrorMessage()

  useEffect(() => {
    const error = (transferWalletsErrors || fetchingCustomersError) as BaseErrorResponse

    if (!!error) {
      setRequestError({
        errorCode: error.status,
        show: true,
      })
    } else {
      resetRequestError()
    }
  }, [fetchingCustomersError, transferWalletsErrors])

  return { requestError }
}
